import { environment } from "src/environments/environment";

export const authorizationServerUrl = environment.authorizationServerUrl;
export const resourceServerUrl = environment.resourceServerUrl;



